import React from "react";

const Java_trim = () => {
  return (
    <div>
      <h1>Java trim</h1>
      <p>This page provides explanations, examples, and common use-cases for Java trim in Java.</p>
    </div>
  );
};

export default Java_trim;
